var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail1D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0V225H328V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1843 201.446C12.6039 204.577 10.5998 210.959 11.9124 214.003C12.6426 215.697 13.5667 213.423 14.0084 212.553C15.198 210.208 15.6472 207.42 16.9106 205.119C18.3409 202.512 18.2174 202.858 18.5228 205.617C18.7867 208 18.9139 210.41 19.2394 212.78C19.3767 213.778 19.3733 214.348 19.8127 212.983C20.4774 210.919 21.2993 209.386 22.3923 207.656C22.8863 206.876 23.1806 205.958 23.1806 207.43C23.1806 207.792 23.1149 214.085 23.7539 213.187C23.9895 212.857 24.094 211.7 24.3092 211.215C24.7229 210.285 25.0637 209.429 25.5811 208.586C25.8022 208.227 25.6436 207.599 26.0827 207.566C27.4856 207.462 28.9492 208.025 30.3464 208.133C36.6714 208.621 39.5724 207.566 45.9005 207.566",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2003 206.876C66.5096 206.459 62.8057 206.654 59.1222 206.254C59.0799 206.25 56.937 205.826 57.8016 205.912C61.541 206.283 65.2335 206.822 68.9927 206.862C73.8819 206.913 78.7133 206.132 83.5907 205.919C86.007 205.812 88.4488 205.785 90.8458 206.261L70.2003 206.876ZM69.296 215.627C69.4517 213.03 69.6425 208.576 69.5117 205.976C69.4501 204.752 69.308 203.559 69.296 202.332C69.2949 202.215 69.2913 201.525 69.1828 201.46C69.0452 201.378 68.9354 201.695 68.818 201.825C68.0073 202.719 67.202 203.619 66.403 204.532C64.1276 207.137 61.8911 209.91 59.3739 212.063C58.6113 212.716 57.8265 213.322 57.036 213.907C56.8459 214.046 56.2529 214.374 56.4656 214.329C56.8344 214.249 57.257 213.986 57.6012 213.835C58.7057 213.35 59.8158 212.902 60.9359 212.492C62.4318 211.945 68.0074 210.319 69.5328 209.955L69.296 215.627Z",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4194 18.0435H8.60608V22.7704H56.4194V18.0435Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.584 18.0435H113.771V22.7704H161.584V18.0435Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.989 18.0435H61.176V22.7704H108.989V18.0435Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.154 18.0435H166.341V22.7704H214.154V18.0435Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1075 8.59033H8.60608V13.3172H85.1075V8.59033Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 30.3335H8.60608V32.2243H319.394V30.3335Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6702 41.6772H8.60608V46.4042H94.6702V41.6772Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.459 41.6772H99.4269V46.4042H142.459V41.6772Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.272 41.6772H147.241V46.4042H190.272V41.6772Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 63.5151H8.60608V71.168H29.644V63.5151Z",
    stroke: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 55.8574H8.60608V63.5103H29.644V55.8574Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 71.1655H8.60608V78.8184H29.644V71.1655Z",
    stroke: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 78.8169H8.60608V86.4698H29.644V78.8169Z",
    stroke: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 86.4722H8.60608V94.1251H29.644V86.4722Z",
    stroke: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 109.428H8.60608V117.081H29.644V109.428Z",
    stroke: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 94.125H8.60608V101.778H29.644V94.125Z",
    stroke: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 117.082H8.60608V124.735H29.644V117.082Z",
    stroke: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 101.774H8.60608V109.427H29.644V101.774Z",
    stroke: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 124.734H8.60608V132.387H29.644V124.734Z",
    stroke: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 63.5151H117.62V71.168H150.134V63.5151Z",
    stroke: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 55.8574H117.62V63.5103H150.134V55.8574Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 71.1655H117.62V78.8184H150.134V71.1655Z",
    stroke: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 78.8169H117.62V86.4698H150.134V78.8169Z",
    stroke: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 86.4722H117.62V94.1251H150.134V86.4722Z",
    stroke: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 109.428H117.62V117.081H150.134V109.428Z",
    stroke: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 94.125H117.62V101.778H150.134V94.125Z",
    stroke: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 117.082H117.62V124.735H150.134V117.082Z",
    stroke: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 101.774H117.62V109.427H150.134V101.774Z",
    stroke: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 124.734H117.62V132.387H150.134V124.734Z",
    stroke: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 63.5151H150.134V71.168H173.084V63.5151Z",
    stroke: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 55.8574H150.134V63.5103H173.084V55.8574Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 71.1655H150.134V78.8184H173.084V71.1655Z",
    stroke: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 78.8169H150.134V86.4698H173.084V78.8169Z",
    stroke: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 86.4722H150.134V94.1251H173.084V86.4722Z",
    stroke: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 109.428H150.134V117.081H173.084V109.428Z",
    stroke: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 94.125H150.134V101.778H173.084V94.125Z",
    stroke: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 117.082H150.134V124.735H173.084V117.082Z",
    stroke: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 101.774H150.134V109.427H173.084V101.774Z",
    stroke: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 124.734H150.134V132.387H173.084V124.734Z",
    stroke: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 63.5151H173.084V71.168H200.816V63.5151Z",
    stroke: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 55.8574H173.084V63.5103H200.816V55.8574Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 71.1655H173.084V78.8184H200.816V71.1655Z",
    stroke: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 78.8169H173.084V86.4698H200.816V78.8169Z",
    stroke: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 86.4722H173.084V94.1251H200.816V86.4722Z",
    stroke: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 109.428H173.084V117.081H200.816V109.428Z",
    stroke: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 94.125H173.084V101.778H200.816V94.125Z",
    stroke: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 117.082H173.084V124.735H200.816V117.082Z",
    stroke: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 101.774H173.084V109.427H200.816V101.774Z",
    stroke: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 124.734H173.084V132.387H200.816V124.734Z",
    stroke: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 63.5151H200.816V71.168H296.443V63.5151Z",
    stroke: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 55.8574H200.816V63.5103H296.443V55.8574Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 71.1655H200.816V78.8184H296.443V71.1655Z",
    stroke: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 78.8169H200.816V86.4698H296.443V78.8169Z",
    stroke: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 86.4722H200.816V94.1251H296.443V86.4722Z",
    stroke: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 109.428H200.816V117.081H296.443V109.428Z",
    stroke: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 94.125H200.816V101.778H296.443V94.125Z",
    stroke: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 117.082H200.816V124.735H296.443V117.082Z",
    stroke: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 101.774H200.816V109.427H296.443V101.774Z",
    stroke: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 124.734H200.816V132.387H296.443V124.734Z",
    stroke: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 63.5151H296.443V71.168H319.394V63.5151Z",
    stroke: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 55.8574H296.443V63.5103H319.394V55.8574Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 71.1655H296.443V78.8184H319.394V71.1655Z",
    stroke: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 78.8169H296.443V86.4698H319.394V78.8169Z",
    stroke: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 86.4722H296.443V94.1251H319.394V86.4722Z",
    stroke: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 109.428H296.443V117.081H319.394V109.428Z",
    stroke: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 94.125H296.443V101.778H319.394V94.125Z",
    stroke: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 117.082H296.443V124.735H319.394V117.082Z",
    stroke: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 101.774H296.443V109.427H319.394V101.774Z",
    stroke: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 124.734H296.443V132.387H319.394V124.734Z",
    stroke: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 63.5151H29.6438V71.168H117.62V63.5151Z",
    stroke: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 55.8574H29.6438V63.5103H117.62V55.8574Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 71.1655H29.6438V78.8184H117.62V71.1655Z",
    stroke: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 78.8169H29.6438V86.4698H117.62V78.8169Z",
    stroke: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 86.4722H29.6438V94.1251H117.62V86.4722Z",
    stroke: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 109.428H29.6438V117.081H117.62V109.428Z",
    stroke: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 94.125H29.6438V101.778H117.62V94.125Z",
    stroke: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 117.082H29.6438V124.735H117.62V117.082Z",
    stroke: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 101.774H29.6438V109.427H117.62V101.774Z",
    stroke: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 124.734H29.6438V132.387H117.62V124.734Z",
    stroke: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 140.091H8.60608V193.661H319.394V140.091Z",
    stroke: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 132.433H8.60608V140.086H319.394V132.433Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2451 144.872H13.3879V188.877H60.2451V144.872Z",
    fill: "#EAEAEA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M110.927 144.872H64.0695V188.877H110.927V144.872Z",
    fill: "#EAEAEA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M161.61 144.872H115.709V188.877H161.61V144.872Z",
    fill: "#EAEAEA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M212.291 144.872H166.39V188.877H212.291V144.872Z",
    fill: "#EAEAEA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 144.872H217.073V188.877H263.929V144.872Z",
    fill: "#EAEAEA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M314.612 144.872H267.755V188.877H314.612V144.872Z",
    fill: "#EAEAEA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9008 161.491C45.9008 160.519 45.0789 159.696 44.1078 159.696H40.8207L40.335 158.501C40.0735 157.791 39.4011 157.305 38.6541 157.305H33.9849C33.2378 157.305 32.5654 157.791 32.3038 158.501L31.8557 159.696H28.5685C27.5599 159.696 26.7754 160.519 26.7754 161.491V172.252C26.7754 173.262 27.5599 174.046 28.5685 174.046H44.1078C45.0789 174.046 45.9008 173.262 45.9008 172.252V161.491ZM40.8207 166.871C40.8207 169.375 38.8035 171.355 36.3381 171.355C33.8355 171.355 31.8557 169.375 31.8557 166.871C31.8557 164.406 33.8355 162.387 36.3381 162.387C38.8035 162.387 40.8207 164.406 40.8207 166.871ZM39.6254 166.871C39.6254 165.078 38.1311 163.583 36.3381 163.583C34.5078 163.583 33.051 165.078 33.051 166.871C33.051 168.702 34.5078 170.16 36.3381 170.16C38.1311 170.16 39.6254 168.702 39.6254 166.871Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5827 161.491C96.5827 160.519 95.7617 159.696 94.7898 159.696H91.5026L91.0171 158.501C90.7555 157.791 90.0831 157.305 89.3361 157.305H84.6669C83.9197 157.305 83.2473 157.791 82.9858 158.501L82.5376 159.696H79.2504C78.2418 159.696 77.4574 160.519 77.4574 161.491V172.252C77.4574 173.262 78.2418 174.046 79.2504 174.046H94.7898C95.7617 174.046 96.5827 173.262 96.5827 172.252V161.491ZM91.5026 166.871C91.5026 169.375 89.4855 171.355 87.0201 171.355C84.5173 171.355 82.5376 169.375 82.5376 166.871C82.5376 164.406 84.5173 162.387 87.0201 162.387C89.4855 162.387 91.5026 164.406 91.5026 166.871ZM90.3074 166.871C90.3074 165.078 88.8132 163.583 87.0201 163.583C85.1897 163.583 83.733 165.078 83.733 166.871C83.733 168.702 85.1897 170.16 87.0201 170.16C88.8132 170.16 90.3074 168.702 90.3074 166.871Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M148.223 161.491C148.223 160.519 147.401 159.696 146.429 159.696H143.141L142.656 158.501C142.394 157.791 141.723 157.305 140.975 157.305H136.306C135.559 157.305 134.887 157.791 134.625 158.501L134.177 159.696H130.889C129.881 159.696 129.097 160.519 129.097 161.491V172.252C129.097 173.262 129.881 174.046 130.889 174.046H146.429C147.401 174.046 148.223 173.262 148.223 172.252V161.491ZM143.141 166.871C143.141 169.375 141.125 171.355 138.659 171.355C136.157 171.355 134.177 169.375 134.177 166.871C134.177 164.406 136.157 162.387 138.659 162.387C141.125 162.387 143.141 164.406 143.141 166.871ZM141.948 166.871C141.948 165.078 140.453 163.583 138.659 163.583C136.828 163.583 135.372 165.078 135.372 166.871C135.372 168.702 136.828 170.16 138.659 170.16C140.453 170.16 141.948 168.702 141.948 166.871Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M198.903 161.491C198.903 160.519 198.082 159.696 197.11 159.696H193.824L193.339 158.501C193.077 157.791 192.403 157.305 191.657 157.305H186.988C186.24 157.305 185.569 157.791 185.307 158.501L184.858 159.696H181.571C180.562 159.696 179.778 160.519 179.778 161.491V172.252C179.778 173.262 180.562 174.046 181.571 174.046H197.11C198.082 174.046 198.903 173.262 198.903 172.252V161.491ZM193.824 166.871C193.824 169.375 191.806 171.355 189.341 171.355C186.838 171.355 184.858 169.375 184.858 166.871C184.858 164.406 186.838 162.387 189.341 162.387C191.806 162.387 193.824 164.406 193.824 166.871ZM192.628 166.871C192.628 165.078 191.134 163.583 189.341 163.583C187.511 163.583 186.053 165.078 186.053 166.871C186.053 168.702 187.511 170.16 189.341 170.16C191.134 170.16 192.628 168.702 192.628 166.871Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M249.586 161.491C249.586 160.519 248.764 159.696 247.794 159.696H244.507L244.021 158.501C243.758 157.791 243.086 157.305 242.339 157.305H237.669C236.923 157.305 236.251 157.791 235.989 158.501L235.54 159.696H232.254C231.245 159.696 230.461 160.519 230.461 161.491V172.252C230.461 173.262 231.245 174.046 232.254 174.046H247.794C248.764 174.046 249.586 173.262 249.586 172.252V161.491ZM244.507 166.871C244.507 169.375 242.489 171.355 240.024 171.355C237.521 171.355 235.54 169.375 235.54 166.871C235.54 164.406 237.521 162.387 240.024 162.387C242.489 162.387 244.507 164.406 244.507 166.871ZM243.311 166.871C243.311 165.078 241.816 163.583 240.024 163.583C238.193 163.583 236.736 165.078 236.736 166.871C236.736 168.702 238.193 170.16 240.024 170.16C241.816 170.16 243.311 168.702 243.311 166.871Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M300.268 161.491C300.268 160.519 299.447 159.696 298.475 159.696H295.189L294.702 158.501C294.441 157.791 293.769 157.305 293.022 157.305H288.353C287.605 157.305 286.933 157.791 286.671 158.501L286.223 159.696H282.936C281.927 159.696 281.143 160.519 281.143 161.491V172.252C281.143 173.262 281.927 174.046 282.936 174.046H298.475C299.447 174.046 300.268 173.262 300.268 172.252V161.491ZM295.189 166.871C295.189 169.375 293.171 171.355 290.706 171.355C288.203 171.355 286.223 169.375 286.223 166.871C286.223 164.406 288.203 162.387 290.706 162.387C293.171 162.387 295.189 164.406 295.189 166.871ZM293.994 166.871C293.994 165.078 292.499 163.583 290.706 163.583C288.876 163.583 287.418 165.078 287.418 166.871C287.418 168.702 288.876 170.16 290.706 170.16C292.499 170.16 293.994 168.702 293.994 166.871Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail1D);
export default __webpack_public_path__ + "static/media/thumbnail-1-d.2dc238005502a3c814c112632d902f27.svg";
export { ForwardRef as ReactComponent };